module.exports = __webpack_public_path__ + "static/img/312.9e9857a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/312.jpg
// module id = nyU9
// module chunks = 0